import * as actionTypes from '../actionTypes/PaymentActionTypes';

const addPayPalPaymentType = (payload) => ({
    type: actionTypes.ADD_PAYPAL_PAYMENT_TYPE_REQUEST,
    payload,
});

const getPromoFinancingOffers = (payload) => ({
    type: actionTypes.GET_PROMO_FINANCING_OFFERS,
    payload,
});

const patchSelectedPromoFinancingOffers = (payload, isPromoFinaceOfferDeclined) => ({
    type: actionTypes.PATCH_SELECTED_PROMO_FINANCING_OFFER,
    payload,
    isPromoFinaceOfferDeclined,
});

const postSelectedRewardOrFinancingOffers = (payload) => ({
    type: actionTypes.POST_SELECTED_REWARD_OR_FINANCING_OFFER,
    payload,
});

const setRewardPromoFinanceDecisionData = (payload) => ({
    type: actionTypes.SET_REWARD_PROMO_FINANCE_DECISION,
    payload,
});

const resetRewardPromoFinanceDecisionData = (payload) => ({
    type: actionTypes.SET_REWARD_PROMO_FINANCE_DECISION,
    payload,
});

export {
    addPayPalPaymentType,
    getPromoFinancingOffers,
    patchSelectedPromoFinancingOffers,
    postSelectedRewardOrFinancingOffers,
    setRewardPromoFinanceDecisionData,
    resetRewardPromoFinanceDecisionData,
};
